var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.userDetails && _vm.userDetails.role === 1)?_c('admin-view'):(_vm.userDetails && _vm.userDetails.role === 2)?_c('tenant-view'):_c('user-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }